import React, { useState } from "react";
import { Info, X } from "lucide-react";

/**
 * Small (i) info icon shown next to "Mystery Loot" badges. Hover shows a
 * tooltip; click opens a modal explaining the concept.
 */
export default function MysteryInfo({ size = 14, color = "#D7A62A" }) {
  const [open, setOpen] = useState(false);
  return (
    <>
      <button
        type="button"
        onClick={(e) => { e.preventDefault(); e.stopPropagation(); setOpen(true); }}
        className="inline-flex items-center align-middle ml-1 opacity-80 hover:opacity-100 transition relative group"
        style={{ color }}
        aria-label="What's Mystery Loot?"
        data-testid="mystery-info-btn"
      >
        <Info size={size} />
        <span
          className="hidden md:inline-block absolute left-1/2 -translate-x-1/2 bottom-full mb-2 whitespace-nowrap px-2 py-1 text-[10px] font-mono uppercase tracking-widest pointer-events-none opacity-0 group-hover:opacity-100 transition"
          style={{ background: "#0F0F0F", border: `1px solid ${color}`, color }}
        >
          What's Mystery Loot?
        </span>
      </button>

      {open && (
        <div
          className="fixed inset-0 z-[60] flex items-center justify-center p-4"
          style={{ background: "rgba(0,0,0,0.85)" }}
          onClick={() => setOpen(false)}
          data-testid="mystery-info-modal"
        >
          <div
            className="loot-card-flat max-w-md w-full p-6 md:p-8 relative"
            style={{ borderColor: color, background: "linear-gradient(135deg, rgba(215,166,42,0.06), rgba(15,15,15,1) 60%)" }}
            onClick={(e) => e.stopPropagation()}
          >
            <button
              type="button"
              onClick={() => setOpen(false)}
              className="absolute top-3 right-3 text-[#F5F2E8]/60 hover:text-[#F5F2E8]"
              aria-label="Close"
              data-testid="mystery-info-close"
            >
              <X size={18} />
            </button>
            <div className="text-4xl mb-2">🎁</div>
            <div className="overline" style={{ color }}>Mystery Loot</div>
            <h2 className="font-display uppercase text-3xl md:text-4xl tracking-tight mt-1 leading-tight">
              You don't know <span style={{ color }}>'til you find it.</span>
            </h2>
            <p className="text-[#F5F2E8]/80 mt-4 leading-relaxed">
              Could be cash. Could be merch. Could be a tattoo voucher.
              Only the winner finds out.
            </p>
            <p className="text-[#F5F2E8]/55 text-sm mt-3 leading-relaxed">
              Mystery drops keep things spicy — the hunt is the reward, the prize is the surprise.
              Hide your phone, watch your back, and good luck out there.
            </p>
            <button
              type="button"
              onClick={() => setOpen(false)}
              className="btn-loot mt-6 w-full text-sm"
              data-testid="mystery-info-ok"
            >
              Got it
            </button>
          </div>
        </div>
      )}
    </>
  );
}
